export const planFeaturesActionTypes = {
  SET_STATE: 'planFeatures/SET_STATE',
  SET_ALL_FEATURES_AND_MODULES: 'planFeatures/SET_ALL_FEATURES_AND_MODULES',
  SET_PLANS: 'planFeatures/SET_PLANS',
  GET_FEATURES_AND_MODULES: 'planFeatures/GET_FEATURES_AND_MODULES',
  GET_PLANS: 'planFeatures/GET_PLANS',
};
